import { RuleObject } from 'antd/lib/form';
import React from 'react';

import TranslateText from 'components/hoc/TranslateText';

import { icoRegExp, icoZahranicnyRegExp } from 'enums/regExp';

const _computeCheckDigit = (vstup: string) => {
    let sum = 0;

    for (let i = 0; i < 7; i++) {
        sum += (vstup.charAt(i).charCodeAt(0) - '0'.charCodeAt(0)) * (8 - i);
    }

    sum %= 11;
    sum = 11 - sum;

    return sum % 10;
};

export const validateICO = (vstup: string) => {
    // 0 - OK
    // 1 - E: nezadano
    // 2 - E: chybna syntaxe
    // 3 - E: chybna kontrolka

    if (!vstup) return 1; // nezadano
    if (!icoRegExp.test(vstup)) return 2; // chybna syntaxe
    // kontrolni cislice
    const sum = _computeCheckDigit(vstup);

    if (sum !== vstup.charAt(7).charCodeAt(0) - '0'.charCodeAt(0)) return 3; // chybna kontrolka

    return 0;
};

export const icoValidation = (getValueFrom?: string) => [
    getValueFrom
        ? ({ getFieldValue }: { getFieldValue: (name: string) => any }) => ({
              validator(_rule: RuleObject, value: string) {
                  const country = getFieldValue(getValueFrom) ?? 'CZ'; // default to CZ

                  // CZ or SK → validateICO
                  if (country === 'CZ' || country === 'SK') {
                      if (!value || validateICO(value) === 0) return Promise.resolve();
                      return Promise.reject(<TranslateText>NEVALIDNI_ICO</TranslateText>);
                  }

                  // Other countries → regex validation
                  if (!value || icoZahranicnyRegExp.test(value)) return Promise.resolve();
                  return Promise.reject(<TranslateText>NEVALIDNI_ICO</TranslateText>);
              }
          })
        : // No getValueFrom → fallback to CZ behavior
          () => ({
              validator(_rule: RuleObject, value: string) {
                  if (!value || validateICO(value) === 0) return Promise.resolve();
                  return Promise.reject(<TranslateText>NEVALIDNI_ICO</TranslateText>);
              }
          })
];

export default icoValidation;
